'use strict'

import React from 'react'
import PropTypes from 'prop-types'

function SalesTooltipContent({ percent, keyword }) {
  return (
    <div className="sales-modal">
      <div className="sales-modal__percentage">{percent}&#37;</div>
      <div className="sales-modal__description">
        models with keyword <span className="sales-modal--keyword">{keyword}</span> have been sold at least once
      </div>
    </div>
  )
}

SalesTooltipContent.propTypes = {
  percent: PropTypes.number.isRequired,
}

export default SalesTooltipContent
